import { DebtLegTerms } from '@/models/DebtLegTerms';

import { Currency } from 'models/Currency';
import { CurrencyConvention } from 'models/CurrencyConvention';
import { IndexList } from 'models/IndexList';
import { createAction } from 'typesafe-actions';

import { CompanyEntityFull } from '../../../../../models/CompanyEntityFull';

export type AddFixedLegPayload = {
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  user_currency_id: Currency['currency_id'];
  market_date: string;
  companyEntities: CompanyEntityFull[];
};
export const addFixedLeg = createAction(
  'debtPricer/leg/addFixedLeg',
)<AddFixedLegPayload>();

export type AddFloatLegPayload = {
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  user_currency_id: Currency['currency_id'];
  market_date: string;
  companyEntities: CompanyEntityFull[];
};
export const addFloatLeg = createAction(
  'debtPricer/leg/addFloatLeg',
)<AddFloatLegPayload>();

export type UpdateLegTermsStateFromFormPayload = {
  data: Partial<DebtLegTerms>;
};
export const updateLegTermsStateFromForm = createAction(
  'debtPricer/leg/updateLegTermsStateFromForm',
)<UpdateLegTermsStateFromFormPayload>();
